import { apiRequest, getResource } from "../api/http";

const query = (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "");
  return entries.length ? `?${new URLSearchParams(entries).toString()}` : "";
};

/** Mailgun events `{ event, recipient, days, page }` → `{ items, next }`; rejects with the API message. */
export const getMailEvents = (params) => getResource(`/api/admin/emails${query(params)}`, { rethrow: true });

/** Mailgun quota of the current cycle: { used, limit, remaining, percent, cycleStart, cycleEnd, cycleDay, error? }. */
export const getMailQuota = (force = false) => getResource(`/api/admin/emails/quota${force ? "?force=true" : ""}`, { rethrow: true });
/** Plan settings: { limit, cycleDay }; rejects with the API message. */
export const updateMailQuota = (body) => apiRequest("put", "/api/admin/emails/quota", { data: body, rethrow: true });
